var map = {
	"./community/customer-01-big.png": "im8w",
	"./community/customer-01.png": "ru5T",
	"./community/customer-02-big.png": "onvS",
	"./community/customer-02.png": "acxa",
	"./community/employee-01-big.png": "XmZO",
	"./community/employee-01.png": "ASp9",
	"./community/employee-02-big.png": "OXaP",
	"./community/employee-02.png": "5aHQ",
	"./community/employee-03-big.png": "UWTr",
	"./community/employee-03.png": "L+pY",
	"./community/employee-04-big.png": "G5GW",
	"./community/employee-04.png": "PwOK",
	"./community/employee-05-big.png": "S2k3",
	"./community/employee-05.png": "EVTD",
	"./community/enenery.jpg": "ya/U",
	"./community/goal-03.png": "iDyo",
	"./community/goal-04.png": "03w5",
	"./community/goal-05.png": "C9nE",
	"./community/goal-08.png": "DemV",
	"./community/goal-09.png": "Q7FP",
	"./community/goal-10.png": "bEiK",
	"./community/goal-13.png": "L+FX",
	"./community/sf-01.png": "ySaO",
	"./community/sfnuanxin.jpg": "S6bz",
	"./community/supplier-01-big.jpg": "FeCl",
	"./community/supplier-01.jpg": "korN",
	"./company/banner.png": "s+GD",
	"./company/business.jpg": "vSP0",
	"./company/business.png": "rObb",
	"./company/shareholder.jpg": "SoOP",
	"./company/shareholder.png": "QO15",
	"./download-icon.png": "HAk4",
	"./home-banner.png": "+7rm",
	"./innovation/banner.png": "3ThK",
	"./innovation/goal-06.png": "Nq6M",
	"./innovation/goal-07.png": "ZMZz",
	"./innovation/goal-11.png": "ItMo",
	"./innovation/goal-12.png": "1CeE",
	"./innovation/goal-13.png": "8Wo4",
	"./innovation/green-info.png": "BTqa",
	"./innovation/item-2-1-big.png": "kZzV",
	"./innovation/item-2-1.png": "Dysr",
	"./innovation/item-2-2-big.png": "T6vx",
	"./innovation/item-2-2.png": "hvnE",
	"./innovation/item-2-3-big.jpg": "rh76",
	"./innovation/item-2-3-big.png": "tjje",
	"./innovation/item-2-3.jpg": "tX0m",
	"./innovation/item-2-3.png": "XghO",
	"./innovation/item-3-1-big.png": "cLYL",
	"./innovation/item-3-1.png": "0xfy",
	"./innovation/item-3-2-big.png": "Ulf8",
	"./innovation/item-3-2.png": "56VQ",
	"./innovation/item-4-1-big.png": "sZiX",
	"./innovation/item-4-1.png": "h1Uy",
	"./innovation/item-4-2-big.png": "KURG",
	"./innovation/item-4-2.png": "JssY",
	"./innovation/item-5-1-big.jpg": "g6/L",
	"./innovation/item-5-1.jpg": "D9g2",
	"./innovation/item-5-2-big.jpg": "rHIc",
	"./innovation/item-5-2.jpg": "zS8Q",
	"./innovation/item-5-3-big.jpg": "HBnV",
	"./innovation/item-5-3.jpg": "Dq0U",
	"./innovation/item-6-1-big.png": "1/ar",
	"./innovation/item-6-1.png": "TG9j",
	"./innovation/item-6-2-big.png": "NEFf",
	"./innovation/item-6-2.png": "r4HB",
	"./innovation/item-6-3-big.png": "w3Og",
	"./innovation/item-6-3.png": "pPug",
	"./innovation/item-6-4-big.png": "JZ5y",
	"./innovation/item-6-4.png": "1P1V",
	"./innovation/item-7-1-big.jpg": "hJIb",
	"./innovation/item-7-1-big.png": "+MAK",
	"./innovation/item-7-1.jpg": "AYFY",
	"./innovation/item-7-1.png": "MfCp",
	"./innovation/item-7-2-big.jpg": "YiVA",
	"./innovation/item-7-2.jpg": "dLd8",
	"./innovation/logo.png": "EjUi",
	"./link-bg-community.png": "kA00",
	"./link-bg-company.png": "axD/",
	"./link-bg-innovation.png": "Lhkb",
	"./link-bg-partnership.png": "fhIY",
	"./partnership/banner.png": "RLfh",
	"./partnership/help-chart.jpg": "lNZv",
	"./partnership/sf-item-01.png": "yxjA",
	"./partnership/sf-item-02.png": "t54a",
	"./partnership/sf-item-03.png": "enxg",
	"./partnership/sf-item-04.png": "iPLQ",
	"./partnership/sf-item-05.jpg": "6gJ2",
	"./partnership/sf-item-05.png": "qcqT",
	"./partnership/sf-item-06.png": "13uQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5lpy";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable ^\.\/.*$
// module id = 5lpy
// module chunks = 2